import React from 'react';
import Project from './Project';
import homely from '../assets/homely.jpeg';
import Farmart from '../assets/farmart.jpeg';
import tutor from '../assets/Geek_tutor.png'

function Portfolio() {
  const data = [
    {
      name: 'Property Management App',
      des: 'The Property Management App is a comprehensive mobile application that simplifies property management tasks, allowing users to efficiently handle rental properties, tenants, financials, maintenance, and communication all in one plac',
      live: 'https://property-management-app-frontend.vercel.app/',
      // github: 'https://github.com/Karemu1842call/Property_management-app-frontend',
      shot: homely,
    },
    {
      name: 'Farmart',
      des:'FarmArt is a versatile platform that connects farmers, food producers, and landowners, offering a diverse range of high-quality food products, animals, and land leases, fostering sustainable agriculture and promoting local food systems',
      live: 'https://farmat.vercel.app/',
      // github: 'https://github.com/Karemu1842call/Farmat',
      shot: Farmart   ,
    },
    {
      name:'Geeks Tutor',
      des:'To Get My proffesional IT services which includes Websites,course management, graphics design, SEO optimization and Data Science. We make your imagination become reality!.',
      live:'http://geeks-app.vercel.app',
      shot: tutor
    }

   
    // {
    //   name: '',
    //   des: '',
    //   live: '',
    //   github: '',
    //   shot: full,
    // },
  ];
  return (
    <section className='portfolio' id='portfolio'>
      <div className='main-text'>
        <h2>My Portfolio</h2>
        <h4>Some Of My Distinguished Works</h4>
      </div>

      <div className='portfolio-content'>
        {data.map((item, i) => (
          <Project item={item} key={i} />
        ))}
      </div>
    </section>
  );
}

export default Portfolio;